import router from '@/router/index'
import store from '@/store/index'
import { Message } from 'element-ui'

// 标志位，用于记录是否已执行登录后的操作
// let isLoginHandled = store.state.permission.isLoginHandled;

const whiteList = ['/login', '/2JQv0Rq3y5.txt', '/PMgEtfKbus.txt', '/userinfo-add'] // 不用重定向的白名单
const wxText = ['/2JQv0Rq3y5.txt', '/PMgEtfKbus.txt']

router.beforeEach(async (to, from, next) => {
  if (wxText.indexOf(to.path) !== -1) {
    return next()
  }
  // 检查本地是否存在bbfAdminTeacherToken
  const hasToken = window.localStorage.getItem('bbfAdminTeacherToken')
  // console.log("hasToken==>", hasToken);
  // console.log("isLoginHandled==>", store.state.permission.isLoginHandled, store);

  // 如果存在bbfAdminTeacherToken，表示用户已登录
  if (hasToken) {
    if (to.path === '/login') {
      next()
    } else if (to.path === '/userinfo-add') {
      next()
    } else {
      try {
        // 判断是否已经执行过登录后的操作
        if (!store.state.permission.isLoginHandled) {
          const user = await store.dispatch('user/getInfo')
          if (user.schoolId == null) {
            next('/userinfo-add')
            // console.log('userinfo-adduserinfo-add');
            return
          } else {
            store.dispatch('school/getSchool', { id: user.schoolId })
            // 设置标志位为true，表示已经处理过登录后的操作
            store.dispatch('permission/loginHandled')
          }
        }

        next()
      } catch (error) {
        console.log(error)
        // 获取用户信息失败
        console.log('获取数据并将数据放到vuex的过程中出错，删除token并转到登录页面重新登录')
        // 删除token并转到登录页面重新登录
        await store.dispatch('user/resetToken')
        Message.error('获取用户信息失败，请稍后重新登录')
        next(`/login?redirect=${to.path}`)
      }
    }
  } else {
    // 不存在bbfAdminTeacherToken，跳转到登录页
    if (whiteList.indexOf(to.path) !== -1) {
      // 在登录白名单中，直接进入
      next()
    } else {
      console.log("没有访问权限的其他页面将重定向到登录页面");
      // 没有访问权限的其他页面将重定向到登录页面
      next(`/login?redirect=${to.path}`)
    }
  }
})

router.afterEach(() => {
  // finish progress bar
})
